import { consentMap, useCookiePreferences, type MediaType } from 'components/GDPRPopup/useCookiePreferences';
import { Trans, useTranslation } from 'react-i18next';
import { SCContainer, SCIconWrapper, SCSubtitle, SCTitle } from './styles';
import Button from 'components/Button'

const LockerIcon = () => <svg viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
</svg>

interface NocookieConsentPlaceholderProps {
    mediaType: MediaType
}

function NocookieConsentPlaceholder({ mediaType }: NocookieConsentPlaceholderProps) {
    const { t } = useTranslation()
    const {cookiePreferences, updateCookiePreferences } = useCookiePreferences();

    const handleAcceptCookie = () => {
        const key = consentMap[mediaType];
        const newState = {...cookiePreferences, [key]: true};
        updateCookiePreferences(newState);
    }

    return (
        <SCContainer>
            <SCIconWrapper>
                <LockerIcon />
            </SCIconWrapper>
            <SCTitle suppressHydrationWarning>{t("noCookieConsent.title", { mediaType })}</SCTitle>
            <SCSubtitle suppressHydrationWarning><Trans
                i18nKey="noCookieConsent.subtitle"
                values={{ mediaType }}
                components={{
                    privacyLink: <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" />
                }}
            /></SCSubtitle>
            <Button onClick={handleAcceptCookie}>{t("noCookieConsent.buttonLabel")}</Button>
        </SCContainer>
    )
}

export { NocookieConsentPlaceholder };
